import TSfHome from './index.vue';

TSfHome.install = app => {
  app.component(TSfHome.name, TSfHome);
};

export default TSfHome;
